import { UPDATE_LISTING_RENT } from '../../constants/actionTypes';

const initialState = 0;

export default function rentPrice(state = initialState, action) {
  switch (action.type) {
    case UPDATE_LISTING_RENT:
      return action.payload.rentPrice || 0;
    default:
      return state;
  }
}
